import { render, staticRenderFns } from "./DraggableListComponent.vue?vue&type=template&id=5a77449a&scoped=true"
import script from "./DraggableListComponent.vue?vue&type=script&lang=js"
export * from "./DraggableListComponent.vue?vue&type=script&lang=js"
import style0 from "./DraggableListComponent.vue?vue&type=style&index=0&id=5a77449a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77449a",
  null
  
)

export default component.exports